var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionItemsLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#664E16"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 23L39.1362 25.004C39.204 26.0017 39.9983 26.796 40.996 26.8638L43 27L40.996 27.1362C39.9983 27.204 39.204 27.9983 39.1362 28.996L39 31L38.8638 28.996C38.796 27.9983 38.0017 27.204 37.004 27.1362L35 27L37.004 26.8638C38.0017 26.796 38.796 26.0017 38.8638 25.004L39 23Z",
    fill: "#F8C549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 29L4.66802 31.4722C4.73583 32.4699 5.53011 33.2642 6.5278 33.332L9 33.5L6.5278 33.668C5.53011 33.7358 4.73583 34.5301 4.66802 35.5278L4.5 38L4.33198 35.5278C4.26417 34.5301 3.46989 33.7358 2.4722 33.668L0 33.5L2.4722 33.332C3.46989 33.2642 4.26417 32.4699 4.33198 31.4722L4.5 29Z",
    fill: "#F8C549"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L8.26348 3.87674C8.33129 4.87443 9.12557 5.66871 10.1233 5.73652L14 6L10.1233 6.26348C9.12557 6.33129 8.33129 7.12557 8.26348 8.12326L8 12L7.73652 8.12326C7.66871 7.12557 6.87443 6.33129 5.87674 6.26348L2 6L5.87674 5.73652C6.87443 5.66871 7.66871 4.87443 7.73652 3.87674L8 0Z",
    fill: "#FFECBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.5V20H22.5V18.5C22.5 17.1188 21.3813 16 20 16C18.6188 16 17.5 17.1188 17.5 18.5ZM15.5 20V18.5C15.5 16.0156 17.5156 14 20 14C22.4844 14 24.5 16.0156 24.5 18.5V20H25C26.1031 20 27 20.8969 27 22V28C27 29.1031 26.1031 30 25 30H15C13.8969 30 13 29.1031 13 28V22C13 20.8969 13.8969 20 15 20H15.5Z",
    fill: "#FFE097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionItemsLocked);
export default __webpack_public_path__ + "static/media/actionItemsLocked.2dace77871d7ae4f050b882a24d666aa.svg";
export { ForwardRef as ReactComponent };